<template>
  <div class="common-warning-modal">
    <div class="modal-backdrop"></div>
    <div class="modal">
      <div class="modal-inner">
        <div class="custom-modal-header">
          <div class="close-btn">
            <div
              class="btn-close"
              @click="$emit('close')"
              v-if="closeIconVisible"
            ></div>
          </div>
        </div>
        <slot :name="header"></slot>
        <slot :name="content"></slot>
        <div class="left-button-container">
          <button
            v-for="(btn, index) in leftButtons"
            :key="index"
            class="buttons"
            :class="`buttons ${btn.className ? btn.className : ''} ${
              btn.loading ? 'loading-btn' : ''
            }`"
            @click="onClick('leftButtons', index)"
            :disabled="btn.loading"
          >
            <div>{{ btn.text }}</div>
            <b-spinner
              label="Spinning"
              small
              style="width: 20px; height: 20px; color: #6a6a74"
              v-if="btn.loading"
            ></b-spinner>
          </button>
        </div>
        <div class="right-button-container">
          <button
            v-for="(btn, index) in rightButtons"
            :key="index"
            :class="`buttons ${btn.className ? btn.className : ''} ${
              btn.loading ? 'loading-btn' : ''
            }`"
            @click="onClick('rightButtons', index)"
            :disabled="btn.loading"
          >
            <div>{{ btn.text }}</div>
            <b-spinner
              label="Spinning"
              small
              style="width: 20px; height: 20px; color: #6a6a74"
              v-if="btn.loading"
            ></b-spinner>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CommonWarningModal',
  props: {
    leftButtons: { required: false, type: Array, default: () => [] },
    rightButtons: { required: false, type: Array, default: () => [] },
    closeIconVisible: { required: false, type: Boolean, default: false },
    header: { required: true, type: String, default: '' },
    content: { required: true, type: String, default: '' },
  },
  methods: {
    async onClick(buttonsDir, index) {
      this.$emit(this[buttonsDir][index].action, index);
    },
  },
};
</script>
<style scoped>
.common-warning-modal .modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1055;
}

.common-warning-modal .modal {
  padding: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 10px;
  display: block;
}

.common-warning-modal .modal .modal-inner {
  width: fit-content;
  height: fit-content;
  background: #fff;
  padding: 30px 40px 20px 40px;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: row;
}

.common-warning-modal .custom-modal-header {
  box-sizing: border-box;
  display: block;
  position: relative;
  width: 100%;
}
.common-warning-modal .modal .btn-close:focus {
  outline: none;
  box-shadow: none;
}

.common-warning-modal .modal .btn-close {
  position: absolute;
  right: -25px;
  top: -14px;
  padding: 0;
}

.common-warning-modal .modal-inner .buttons {
  background: white;
  border: 1px solid #cdcdcd;
  color: #9090a2;
  border-radius: 7px;
  font-size: 18px;
  line-height: 30px;
  padding: 3px 13px;
  transition: all 0.3s;
}

.common-warning-modal .modal-inner .button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.common-warning-modal .loading-btn {
  position: relative;
}

.common-warning-modal .loading-btn div {
  visibility: hidden;
}

.common-warning-modal .loading-btn span {
  position: absolute;
  top: 7px;
  left: calc(50% - 10px);
}
.common-warning-modal .modal-inner button.buttons div {
  font-size: 14px;
}

.common-warning-modal .modal-inner .left-button-container,
.common-warning-modal .modal-inner .right-button-container {
  width: fit-content;
}
</style>
